import Enums from '@core/types/api/Enums';

export const PRODUCT_DELIVERY_TYPE_OPTIONS = [
  { label: 'External Hauling', value: Enums.ProductDeliveryType.Hauling },
  { label: 'Internal Hauling', value: Enums.ProductDeliveryType.InternalHauling },
  { label: 'Pick up', value: Enums.ProductDeliveryType.Pickup },
];

/** User-facing labels for every `ProductCategory` value — single source of truth for display strings. */
export const PRODUCT_CATEGORY_LABELS: Record<Enums.ProductCategory, string> = {
  [Enums.ProductCategory.ReadyMix]: 'Ready Mix',
  [Enums.ProductCategory.Aggregate]: 'Aggregates',
  [Enums.ProductCategory.Asphalt]: 'Asphalt',
  [Enums.ProductCategory.Resale]: 'Resale',
  [Enums.ProductCategory.Precast]: 'Precast',
  [Enums.ProductCategory.Other]: 'Other',
  [Enums.ProductCategory.Charge]: 'Charge',
};

export const getUserFacingCategoryName = (category: Enums.ProductCategory): string =>
  PRODUCT_CATEGORY_LABELS[category];

export const PRODUCT_CATEGORY_OPTIONS: { value: Enums.ProductCategory | ''; label: string }[] = [
  { value: '', label: 'All product types' },
  {
    value: Enums.ProductCategory.ReadyMix,
    label: PRODUCT_CATEGORY_LABELS[Enums.ProductCategory.ReadyMix],
  },
  {
    value: Enums.ProductCategory.Aggregate,
    label: PRODUCT_CATEGORY_LABELS[Enums.ProductCategory.Aggregate],
  },
  {
    value: Enums.ProductCategory.Asphalt,
    label: PRODUCT_CATEGORY_LABELS[Enums.ProductCategory.Asphalt],
  },
];
